import SgpBreadcrumb from './breadcrumb.vue'

SgpBreadcrumb.install = function (Vue) {
  Vue.component(SgpBreadcrumb.name, SgpBreadcrumb)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(SgpBreadcrumb)
}

export default SgpBreadcrumb
